export default __webpack_public_path__ + "static/freizeitleben-a2432769062a1fa62aa800afc4caa3d8.png";